import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Button,
  Box,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const HelpBanner = ({ mode, onOpenFullInstructions }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = () => {
    setExpanded(!expanded);
  };

  let title = '';
  let tips = [];

  switch (mode) {
    case 'encrypt':
      title = 'How to Encrypt Files';
      tips = [
        { 
          icon: <LightbulbIcon color="primary" />,
          text: 'Upload an image first, then create a strong encryption key.'
        },
        { 
          icon: <InfoIcon color="info" />,
          text: 'The encryption process happens in your browser - your data never leaves your device unencrypted.'
        },
        { 
          icon: <WarningIcon color="warning" />,
          text: 'Save your encryption key! Without it, you cannot decrypt your file later.'
        }
      ];
      break;
    case 'decrypt':
      title = 'How to Decrypt Files';
      tips = [
        { 
          icon: <LightbulbIcon color="primary" />,
          text: 'You need both the encrypted data and the original encryption key.'
        },
        { 
          icon: <InfoIcon color="info" />,
          text: 'Make sure to select the correct file format that was used during encryption.'
        },
        { 
          icon: <WarningIcon color="warning" />,
          text: 'If decryption fails, double-check your encryption key and ensure the encrypted data is complete.'
        }
      ];
      break;
    default:
      title = 'Application Instructions';
      tips = [
        {
          icon: <InfoIcon color="info" />,
          text: 'This application allows you to encrypt files before uploading them to Vercel Blob Storage.'
        }
      ];
  }

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        mb: 3, 
        borderLeft: '4px solid',
        borderColor: 'primary.main',
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HelpOutlineIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="subtitle1">{title}</Typography>
        </Box>
        <Box>
          <Button 
            color="primary" 
            size="small" 
            onClick={onOpenFullInstructions}
            sx={{ mr: 1 }}
          >
            Full Instructions
          </Button>
          <IconButton 
            size="small" 
            onClick={handleToggleExpand}
            aria-expanded={expanded}
            aria-label={expanded ? "show less" : "show more"}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>
      
      <Collapse in={expanded}>
        <Box sx={{ px: 2, pb: 2 }}>
          <List dense disablePadding>
            {tips.map((tip, index) => (
              <ListItem key={index} disableGutters sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  {tip.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={tip.text} 
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default HelpBanner;